import { IChainMeta, IChainPair } from '@kattana-io/common';
import { ColumnNames } from '../../components/Modal/TickersModal/columns';
import useTicker from '../../hooks/useTicker';
import {
  formatPriceUSD,
  formatLiquidity,
  formatBaseVolume,
} from '../../components/Modal/TickersModal/helper';
import { formatAPY } from '../../helpers/formatters';
import { formatTimestamp } from '../../components/DexTrades/formatters';
import ethIcon from '../../assets/images/chains/ethereum.svg';
import bscIcon from '../../assets/images/chains/bsc_chain.svg';
import avaxIcon from '../../assets/images/chains/avalance.svg';
import polygonIcon from '../../assets/images/chains/polygon.svg';
import tronIcon from '../../assets/images/chains/tron.svg';
import bttcIcon from '../../assets/images/chains/bttc.svg';
import ftmIcon from '../../assets/images/chains/fantom.svg';
import elrondIcon from '../../assets/images/chains/elrond.svg';
import auroraIcon from '../../assets/images/chains/aurora.svg';
import klaytnIcon from '../../assets/images/chains/klaytn.svg';
import optimismIcon from '../../assets/images/chains/optimism.svg';
import kavaIcon from '../../assets/images/chains/kava.svg';
import harmonyIcon from '../../assets/images/chains/harmony.svg';
import cronosIcon from '../../assets/images/chains/cronos.svg';
import moonbeamIcon from '../../assets/images/chains/moonbeam.png';
import meterIcon from '../../assets/images/chains/moonbeam.png';
import okexIcon from '../../assets/images/chains/okex.png';

export const getChainStatistics = (meta: IChainMeta) => {
  const { last_block, last_update, txs } = meta || {};

  return {
    'Last block': last_block,
    'Last update': `${formatTimestamp(last_update)}`,
    '24h transactions': txs,
  };
};

export const getChainTableData = (pairs: IChainPair[]) => {
  return pairs.map((item, index) => {
    const ticker = useTicker(item.pair);
    const diffField = item.pair.flipped ? 'diff_b' : 'diff_a';
    const timePriceChangeFields = {
      '5m': item['5m'][diffField].toFixed(2),
      '1h': item['1h'][diffField].toFixed(2),
      '6h': item['6h'][diffField].toFixed(2),
      '24h': item['24h'][diffField].toFixed(2),
    };

    return {
      [ColumnNames.star]: `${index + 1}`,
      [ColumnNames.exchange]: item.pair.exchange,
      [ColumnNames.pair]: `${item.pair.chain}/${item.pair.address}`,
      [ColumnNames.price]: formatPriceUSD(ticker.price_usd),
      [ColumnNames.liquidity]: formatLiquidity(item.pair.liquidity) || '-',
      [ColumnNames.volume]: formatBaseVolume(item.pair.volume) || '-',
      [ColumnNames.contract]: item.pair.address,
      [ColumnNames.apy]: formatAPY(item.pair.annual_percentage_yield) || '-',
      txns: `${item['24h'].txns}`,
      ...timePriceChangeFields,
    };
  });
};

export const getMobileChainTableData = (pairs: IChainPair[]) => {
  return pairs.map((item, index) => {
    const ticker = useTicker(item.pair);
    const diffField = item.pair.flipped ? 'diff_b' : 'diff_a';
    const timePriceChangeFields = {
      '5m': item['5m'][diffField].toFixed(2),
      '1h': item['1h'][diffField].toFixed(2),
      '6h': item['6h'][diffField].toFixed(2),
      '24h': item['24h'][diffField].toFixed(2),
    };

    return {
      [ColumnNames.star]: `${index + 1}`,
      [ColumnNames.exchange]: item.pair.exchange,
      [ColumnNames.pair]: item.pair,
      [ColumnNames.price]: formatPriceUSD(ticker.price_usd),
      [ColumnNames.liquidity]: formatLiquidity(item.pair.liquidity) || '-',
      [ColumnNames.volume]: formatBaseVolume(item.pair.volume) || '-',
      [ColumnNames.contract]: item.pair,
      [ColumnNames.apy]: formatAPY(item.pair.annual_percentage_yield) || '-',
      txns: `${item['24h'].txns}`,
      ...timePriceChangeFields,
    };
  });
};

export const chainLogosMapping = {
  KAVA: kavaIcon,
  BSC_TESTNET: bscIcon,
  CRONOS: cronosIcon,
  BSC: bscIcon,
  ETH: ethIcon,
  OPTIMISM: optimismIcon,
  OKX: okexIcon,
  METER: meterIcon,
  POLYGON: polygonIcon,
  MOONBEAM: moonbeamIcon,
  AURORA: auroraIcon,
  KLAYTN: klaytnIcon,
  HARMONY: harmonyIcon,
  TRON: tronIcon,
  BTTC: bttcIcon,
  AVAX: avaxIcon,
  ELROND: elrondIcon,
  FTM: ftmIcon,
};
